"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminAlertsControllerListListingUrlAlertsV1StatusEnum = exports.AdminAlertsApi = void 0;
var runtime = __importStar(require("../runtime"));
var PatchAdminAlertConfigDto_1 = require("../models/PatchAdminAlertConfigDto");
/**
 *
 */
var AdminAlertsApi = /** @class */ (function (_super) {
    __extends(AdminAlertsApi, _super);
    function AdminAlertsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates request options for adminAlertsControllerClearListingUrlSuppressionV1 without sending the request
     */
    AdminAlertsApi.prototype.adminAlertsControllerClearListingUrlSuppressionV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['id'] == null) {
                            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling adminAlertsControllerClearListingUrlSuppressionV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/admin/alerts/listing-urls/{id}/clear-suppression";
                        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Allow this listing URL failure signal to alert again
     */
    AdminAlertsApi.prototype.adminAlertsControllerClearListingUrlSuppressionV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.adminAlertsControllerClearListingUrlSuppressionV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Allow this listing URL failure signal to alert again
     */
    AdminAlertsApi.prototype.adminAlertsControllerClearListingUrlSuppressionV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.adminAlertsControllerClearListingUrlSuppressionV1Raw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates request options for adminAlertsControllerEvaluateV1 without sending the request
     */
    AdminAlertsApi.prototype.adminAlertsControllerEvaluateV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters['dryRun'] != null) {
                            queryParameters['dryRun'] = requestParameters['dryRun'];
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/admin/alerts/evaluate";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Evaluate operational alerts now
     */
    AdminAlertsApi.prototype.adminAlertsControllerEvaluateV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.adminAlertsControllerEvaluateV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Evaluate operational alerts now
     */
    AdminAlertsApi.prototype.adminAlertsControllerEvaluateV1 = function () {
        return __awaiter(this, arguments, void 0, function (requestParameters, initOverrides) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.adminAlertsControllerEvaluateV1Raw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates request options for adminAlertsControllerGetConfigV1 without sending the request
     */
    AdminAlertsApi.prototype.adminAlertsControllerGetConfigV1RequestOpts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/admin/alerts/config";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Get wired operational alert thresholds and recipients
     */
    AdminAlertsApi.prototype.adminAlertsControllerGetConfigV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.adminAlertsControllerGetConfigV1RequestOpts()];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Get wired operational alert thresholds and recipients
     */
    AdminAlertsApi.prototype.adminAlertsControllerGetConfigV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.adminAlertsControllerGetConfigV1Raw(initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates request options for adminAlertsControllerGetHistoryV1 without sending the request
     */
    AdminAlertsApi.prototype.adminAlertsControllerGetHistoryV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters['page'] != null) {
                            queryParameters['page'] = requestParameters['page'];
                        }
                        if (requestParameters['limit'] != null) {
                            queryParameters['limit'] = requestParameters['limit'];
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/admin/alerts/history";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Paginated operational alert send attempts, newest first
     */
    AdminAlertsApi.prototype.adminAlertsControllerGetHistoryV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.adminAlertsControllerGetHistoryV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Paginated operational alert send attempts, newest first
     */
    AdminAlertsApi.prototype.adminAlertsControllerGetHistoryV1 = function () {
        return __awaiter(this, arguments, void 0, function (requestParameters, initOverrides) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.adminAlertsControllerGetHistoryV1Raw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates request options for adminAlertsControllerGetStatusV1 without sending the request
     */
    AdminAlertsApi.prototype.adminAlertsControllerGetStatusV1RequestOpts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/admin/alerts/status";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Last operational alert evaluation snapshot
     */
    AdminAlertsApi.prototype.adminAlertsControllerGetStatusV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.adminAlertsControllerGetStatusV1RequestOpts()];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Last operational alert evaluation snapshot
     */
    AdminAlertsApi.prototype.adminAlertsControllerGetStatusV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.adminAlertsControllerGetStatusV1Raw(initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates request options for adminAlertsControllerListListingUrlAlertsV1 without sending the request
     */
    AdminAlertsApi.prototype.adminAlertsControllerListListingUrlAlertsV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters['status'] != null) {
                            queryParameters['status'] = requestParameters['status'];
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/admin/alerts/listing-urls";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Open or suppressed SonyLIV and Hotstar listing URL alerts
     */
    AdminAlertsApi.prototype.adminAlertsControllerListListingUrlAlertsV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.adminAlertsControllerListListingUrlAlertsV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Open or suppressed SonyLIV and Hotstar listing URL alerts
     */
    AdminAlertsApi.prototype.adminAlertsControllerListListingUrlAlertsV1 = function () {
        return __awaiter(this, arguments, void 0, function (requestParameters, initOverrides) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.adminAlertsControllerListListingUrlAlertsV1Raw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates request options for adminAlertsControllerMarkListingUrlFalsePositiveV1 without sending the request
     */
    AdminAlertsApi.prototype.adminAlertsControllerMarkListingUrlFalsePositiveV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['id'] == null) {
                            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling adminAlertsControllerMarkListingUrlFalsePositiveV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/admin/alerts/listing-urls/{id}/false-positive";
                        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Suppress this listing URL and failure signal
     */
    AdminAlertsApi.prototype.adminAlertsControllerMarkListingUrlFalsePositiveV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.adminAlertsControllerMarkListingUrlFalsePositiveV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Suppress this listing URL and failure signal
     */
    AdminAlertsApi.prototype.adminAlertsControllerMarkListingUrlFalsePositiveV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.adminAlertsControllerMarkListingUrlFalsePositiveV1Raw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates request options for adminAlertsControllerPatchConfigV1 without sending the request
     */
    AdminAlertsApi.prototype.adminAlertsControllerPatchConfigV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['patchAdminAlertConfigDto'] == null) {
                            throw new runtime.RequiredError('patchAdminAlertConfigDto', 'Required parameter "patchAdminAlertConfigDto" was null or undefined when calling adminAlertsControllerPatchConfigV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/admin/alerts/config";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'PATCH',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, PatchAdminAlertConfigDto_1.PatchAdminAlertConfigDtoToJSON)(requestParameters['patchAdminAlertConfigDto']),
                            }];
                }
            });
        });
    };
    /**
     * Update operational alert thresholds and recipients
     */
    AdminAlertsApi.prototype.adminAlertsControllerPatchConfigV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.adminAlertsControllerPatchConfigV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Update operational alert thresholds and recipients
     */
    AdminAlertsApi.prototype.adminAlertsControllerPatchConfigV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.adminAlertsControllerPatchConfigV1Raw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return AdminAlertsApi;
}(runtime.BaseAPI));
exports.AdminAlertsApi = AdminAlertsApi;
/**
 * @export
 */
exports.AdminAlertsControllerListListingUrlAlertsV1StatusEnum = {
    Open: 'open',
    FalsePositive: 'false_positive'
};
